import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const POTitleLabel = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 16px;
    text-align: right;
    width: 20%;
    ${media.mobileDevice`     
    width: 30%;
    font-size: ${({ isPaymentScreen }) =>
    isPaymentScreen ? '14px' : '16px'};
    `}
`;
export const POTitleValue = styled.div`
    font-family: ${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen
            ? 'AvenirNextWorld Regular'
            : 'AvenirNextWorld Demi'};
    font-size: 16px;
    color: ${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? '#140F4B' : '#4f4f4f'};
    text-align: right;
    width: 20%;
    ${media.mobileDevice`     
    width: 30%;
    opacity:${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? '1' : ''};   
    `}
`;

export const SumQtyLabel = styled.div`
    width: 10%;
    text-align: right;
    padding-right: ${({ isPaymentScreen }) =>
        isPaymentScreen ? '5px' : '4px'};
    ${media.mobileDevice`     
    width: 20%;
    text-align: left;
    `}
`;

export const PONumber = styled.div`
    width: 70%;
    ${media.mobileDevice`     
    width: 50%;
    word-break: break-word;
    `}
`;
